var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "address book_02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC\\u5207\\u56FE",
    transform: "translate(-91.000000, -149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(91.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-4",
    stroke: "#F3CDC2",
    strokeWidth: 2,
    fillRule: "nonzero",
    x: 5.88461538,
    y: 3,
    width: 17.2307692,
    height: 21,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#F3CDC2",
    fill: "#F3CDC2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsTab);
export default __webpack_public_path__ + "static/media/ContactsTab.2e359318f5ec6f0f05538e6a8722f5cf.svg";
export { ForwardRef as ReactComponent };